require('./capability_ng_favorites_module');
require('./commands/load_favorites_command');
require('./routes');
require('./views/my_favorites_category/my_favorites_category_controller');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-favorites/src/core.ts